import React from 'react';
import Modal from './Modal';

const SuccessModal = ({ isOpen, onClose, orderId, action, status }) => {

    const getActionText = (action) => {
        switch (action) {
            case 'approve':
                return 'approved';
            case 'reject':
                return 'rejected';
            case 'finalize':
                return 'finalized';
            default:
                return action;
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'APPROVED1':
                return 'Approved (First Level)';
            case 'APPROVED2':
                return 'Approved (Second Level)';
            case 'REJECTED':
                return 'Rejected';
            case 'COMPLETED':
                return 'Completed';
            default:
                return status;
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} hideCloseButton>
            <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                    <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                    Order {getActionText(action)} successfully!
                </h3>
                <div className="text-sm text-gray-600 space-y-2">
                    <p><strong>Order ID:</strong> {orderId}</p>
                    <p><strong>New Status:</strong> {getStatusText(status)}</p>
                </div>
                <div className="mt-6">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SuccessModal; 